import * as wasm from "./amll_lyric_bg.wasm";
export * from "./amll_lyric_bg.js";
import { __wbg_set_wasm } from "./amll_lyric_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
